import { render } from "./Mb001.vue?vue&type=template&id=2e4e0681&scoped=true"
import script from "./Mb001.vue?vue&type=script&lang=js"
export * from "./Mb001.vue?vue&type=script&lang=js"

import "./Mb001.vue?vue&type=style&index=0&id=2e4e0681&lang=scss&scoped=true"
import "./Mb001.vue?vue&type=style&index=1&id=2e4e0681&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4e0681"]])

export default __exports__